/** @format */

import React from 'react';
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';

// Routes need to be prefixed in the workshop
const WORKSHOP_PATH = '/appdir/App';

const pathPrefixer = (path) =>
  process.env.REACT_APP_FE_WORKSHOP ? `${WORKSHOP_PATH}${path}` : path;

const Link = ({ to, gaTrackId, ...props }) => (
  <RouterLink to={pathPrefixer(to)} data-ga-track-id={gaTrackId} {...props} />
);

const NavLink = ({ to, gaTrackId, ...props }) => (
  <RouterNavLink to={pathPrefixer(to)} data-ga-track-id={gaTrackId} {...props} />
);

export { Link, NavLink, pathPrefixer };
